module.exports = __webpack_public_path__ + "img/gasoline.68f64015.svg";